import { createSlice, PayloadAction } from "@reduxjs/toolkit";
export interface PrepaidData {
  bookingId: string;
  companyId: string;
  companyName: string;
  cabId: string;
  bookDate: string;
  invoiceNumber: string;
  credit: number;
  mobile: string;
  distance: number;
  duration: string;
  fare: number;
  from: string;
  to: string;
  goods: string;
  invoiceDate: string;
}
interface PrepaidState {
  data: PrepaidData[];
  loading: boolean;
  error?: string;
  fromDate: string | null;
  toDate: string | null;
  searchQuery: string;
  totalFare?: any;
  tablelength?: any;
}
const initialState: PrepaidState = {
  data: [],
  loading: false,
  error: undefined,
  fromDate: null,
  toDate: null,
  searchQuery: "",
};
const prepaidSlice = createSlice({
  name: "prepaid",
  initialState,
  reducers: {
   fetchPrepaidTripRequest(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchPrepaidTripSuccess(state, action) {
      state.data = action.payload.data;
      state.totalFare = action.payload.totalFare;
      state.tablelength = action.payload.tablelength;
      state.loading = false;
    },
    fetchPrepaidTripFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setFromDate(state, action: PayloadAction<string | null>) {
      state.fromDate = action.payload;
    },
    setToDate(state, action: PayloadAction<string | null>) {
      state.toDate = action.payload;
    },
    setSearchQuery(state, action: PayloadAction<string>) {
      state.searchQuery = action.payload;
    },
  },
});
export const {
  fetchPrepaidTripRequest,
  fetchPrepaidTripSuccess,
  fetchPrepaidTripFailure,
  setFromDate,
  setToDate,
  setSearchQuery,
} = prepaidSlice.actions;
export default prepaidSlice.reducer;
